import React , {Component} from 'react';
import axios from 'axios';
// import '../../css/normalize.css'
// import '../../css/grid.css'
// import '../../css/grid.css'
import './Collaborate.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

class Collaborate  extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.uploadCollabration = this.uploadCollabration.bind(this);
  }

  state = {
    logged_in: false,
    login_email:"",
    name : "",
    author : "",
    link : "",
    attachment: [],
    description: "",
    page_num : 1,
    existing_collabrations : [],
    endpoint: 'https://vims.cis.udel.edu/geography/seaice/services/',
  }

  downloadExistingCollabration = (name) => {
    let url = this.state.endpoint + 'dwnldcollab/'+
    "name=" + name;
      axios({
        method: 'get',
        url: url,
        responseType: 'blob',
      }).then( (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'download.zip');
        document.body.appendChild(link);
        link.click();        })
        .catch( (error) => {
          console.log(error);
        });
  }

  loadExistingCollabration = () => {
    let url = this.state.endpoint + 'getcollab/' +
    'page=' + this.state.page_num;

      axios({
        method: 'get',
        url: url,
      }).then( (response) => {
        console.log('Response', response.data);
        this.setState({existing_collabrations : response.data['Success']});
        });
  }

  handleChange = (event) => {
    if (event.target.name !== "attachment"){
      console.log(event.target.value, event.target.name)
      this.setState({
        ...this.state,
        [event.target.name]: event.target.value
      });
    }
    else if (event.target.name === "attachment"){
      console.log(event.target.files);

      this.setState({ attachment : event.target.files});
    }
  }

  getFileExtension = (filename) => {
    let ext = /^.+\.([^.]+)$/.exec(filename);
    return ext == null ? "" : ext[1];
  }

  validURL = (url) => {
    var pattern = new RegExp('^(http(s)?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return pattern.test(url);
  }

  uploadCollabration = (event) => {
    event.preventDefault();
    console.log(this.state.attachment , this.state.attachment.length !== 0)
    if ((this.state.name !== "") &&  (this.state.description !== "")){
      if((this.state.link !== "") || (this.state.attachment.length !== 0)){
          if((this.state.link !== "" && this.validURL(this.state.link)) || this.state.link === ""){
            if (this.getFileExtension(this.state.attachment[0].name) === "zip"){
              let toastId = null;
              let form_data = new FormData();
              form_data.append('name',this.state.name)
              form_data.append('email', this.state.login_email)
              form_data.append('author', this.state.author)
              form_data.append('link', this.state.link)
              form_data.append('attachment', this.state.attachment[0])
              form_data.append('description', this.state.description)

              console.log(form_data)
              let url = this.state.endpoint + 'upldcollab/'
              axios.request({
                method: 'post',
                url: url,
                data: form_data,
                headers: {
                  'Content-Disposition': 'attachment; filename= this.state.attachment[0].name'
                },
                onUploadProgress: (p) => {
                  const progress = p.loaded / p.total;

                  if (toastId == null) {
                    toastId = toast('Uploading Files...', { progress: progress})
                    console.log(toastId)
                  }else {
                      toast.update(toastId, {
                        progress: progress
                  })
                }
              }
              }).then( (response) => {
                  console.log(toastId)
                  toast.dismiss(toastId)
                  toast('Uploaded!', { autoClose: 3000, hideProgressBar: true })
                  window.location.reload(false);
                })
                .catch((error) => {
                  toast("Error. Please try again or send an email to vims@cis.udel.edu", { autoClose: 3000, hideProgressBar: true })
                });
              }else{
              toast('Only file with .zip extension can be uploaded.', { autoClose: 3000, hideProgressBar: true });
            }
          }else{
            toast('Invalid URL.', { autoClose: 3000, hideProgressBar: true });
          }
        }else{
          toast('Either link must be provided or file must be attached.', { autoClose: 3000, hideProgressBar: true });
        }
      }else{
        toast('Name and description must be provided before uploading file.', { autoClose: 3000, hideProgressBar: true });
    }
  }



  render() {

    let showcase_link = (<th>Link</th>)
    let download_link = (<th>Download</th>)

    let logged_in = this.state.logged_in;

    let collaborations = this.state.existing_collabrations.map( (existing_collabration, index ) =>  {

    const pStyle = {
      textDecorationLine: 'underline',
      color:'purple'
    };

      return(
          <React.Fragment  key = {existing_collabration.name}>
            <tr>
              <td > {existing_collabration.name} </td>
              <td > {existing_collabration.email} </td>
              <td > {existing_collabration.author} </td>
              <td > {existing_collabration.link} </td>
              <td className = 'collab' style = {pStyle} onClick = {() => this.downloadExistingCollabration(existing_collabration.name)}> Click to Download </td>
            </tr>

            <tr >
              <td colSpan = "5" >Description : {existing_collabration.description}</td>
            </tr>
          </React.Fragment>

      )
    })

    return (

      <div>
        <form onSubmit={this.handleSubmit}>
        <div className = "api">
          <h6>Upload or link your code below to collaborate</h6>
          <table>
              <tbody>
              <tr>
              <td> Name </td>
              <td> E-mail </td>
              <td> Author </td>
              <td> Link </td>
              <td> Attachment </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <input name= "name" type="text" disabled = {!logged_in} value={this.state.value} onChange={this.handleChange} />
                  </label>
                 </td>
                <td>
                  <label>
                    <input name= "email" type="email" disabled = {true} value={this.state.login_email} onChange={this.handleChange} />
                  </label>
                 </td>
                <td>
                  <label>
                    <input name= "author" type="text" disabled = {true}  value={this.state.author} onChange={this.handleChange} />
                  </label>
                 </td>
                <td>
                  <label>
                    <input name= "link" type="text" disabled = {!logged_in} value={this.state.value} onChange={this.handleChange} />
                  </label>
                </td>
                <td>
                  <label>
                    <input name= "attachment" type="file" disabled = {!logged_in} onChange={this.handleChange} />
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          <div className = 'upload'>
            <textarea name = "description" disabled = {!logged_in} placeholder=" Enter description of your code" onChange={this.handleChange} value={this.state.value}></textarea>
          </div>
          {!logged_in?
            <button disabled = {!logged_in}>
              Login to submit
            </button>:
            <button onClick = {this.uploadCollabration}>
              Submit
            </button>
          }
          <ToastContainer autoClose={8000} />
        </div>
        </form>

        <div className = "api">

          <h6>Existing Collabrations</h6>
            <p>Please find below the list of already existing code</p><br></br>
          <table>
            <thead>
              <tr>
              <th> Name </th>
              <th> E-mail </th>
              <th> Author </th>
              {showcase_link}
              {download_link}
              </tr>
            </thead>
            <tbody>
              {collaborations}
            </tbody>
          </table>
        </div>
      </div>
    );
  }


  componentDidMount(){
    console.log('Collaborate');
    this.loadExistingCollabration()
    let logged_in = JSON.parse(localStorage.getItem('logged_in'));
    console.log(logged_in)
    if (logged_in){
      this.setState({
        logged_in: logged_in,
        author: localStorage.getItem('first_name') + " " + localStorage.getItem('last_name'),
        login_email:localStorage.getItem('email')
      })
    }else{
      this.setState({
        logged_in: logged_in,
        author:"",
        login_email:""
      })
    }
  }
}

export default Collaborate;



// WEBPACK FOOTER //
// ./src/components/Collaborate/Collaborate.js